import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { PharmacyInconsistencyFieldType } from './models/PharmacyInconsistencyFieldType';

export const PharmacyInconsistencyFieldTypeStore = types.compose(
  getBaseStore<Instance<typeof PharmacyInconsistencyFieldType>, SnapshotIn<typeof PharmacyInconsistencyFieldType>>(
    PharmacyInconsistencyFieldType,
    'pharmacyInconsistencyFieldTypeId',
    'pharmacyInconsistencyFieldType',
  ),
  types.model('PharmacyInconsistencyFieldTypeStore', {}),
);

export type PharmacyInconsistencyFieldTypeType = Instance<typeof PharmacyInconsistencyFieldType>;
